import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  position: 'relative',
  mb: 1.5,
};

export const icon: SxStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  pl: (p) => p.spacing(2),
  color: (p) => p.palette.grey[500],
  zIndex: 9,
};
